import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRepsOutletContext } from 'pages/Reps.context'
import { useParams } from 'react-router-dom'
import { FuncionariosAssociadosRep } from '../FuncionariosAssociados'

export default function AssociarFuncionariosRep() {
    const { id } = useParams()
    const { data } = useRepsOutletContext()
    const rep = data?.find(item => item.id === Number(id))

    if (!rep) return null

    return (
        <Dialog.Root open={hasPermission(['read', 'Funcionários'])}>
            <Dialog.Title action="Funcionários do REP">
                {rep.nome || rep.numeroSerie}
            </Dialog.Title>
            <Dialog.Content>
                <FuncionariosAssociadosRep repId={rep.id} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
